import { render, staticRenderFns } from "./NewPasswordDialog.vue?vue&type=template&id=7868dd56"
import script from "./NewPasswordDialog.vue?vue&type=script&lang=js"
export * from "./NewPasswordDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7868dd56')) {
      api.createRecord('7868dd56', component.options)
    } else {
      api.reload('7868dd56', component.options)
    }
    module.hot.accept("./NewPasswordDialog.vue?vue&type=template&id=7868dd56", function () {
      api.rerender('7868dd56', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/auth/NewPasswordDialog.vue"
export default component.exports